import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  DialogTitle,
  Box,
  Dialog,
  Typography,
  DialogContent,
  Slide,
  IconButton,
  Grid,
  DialogContentText,
  Button,
  DialogActions,
  Card,
  Badge,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExpandIcon, RightArrow } from 'component/OwnerCard/OwnerCard';
import { getMoxoBinderdetails } from 'api/rcpapiService';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CommunicationAvataGroup } from 'component/ExpandedBuyerCard/ExpendedCardDocumentation';
import { fontsize10, poppins400, poppins500 } from 'theme/common.style';
import Moxochat from './Moxochat';
import { styled } from '@mui/material/styles';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { LOGGED_FROM, USER_MAIL_ID } from 'constant/app.config';

function Moxochatloop({
  open,
  onClose,
  currentBinder,
  setCurrentBinder,
  activityfun,
  lastref,
}) {
  const history = useHistory();
  const {
    msgcount,
    setMsgcount,
    msgbtn,
    moxochatloop,
    setMoxochatloop,
    ischatopen,
    setIschatopen,
    setShowMessage,
    setMessagedata,
  } = useContext(datacontext);
  const scrollDoneRef = useRef(false);
  const scrollTimerRef = useRef(null);

  const [loopdata, setLoopdata] = useState([]);
  const [openchat, setOpenchat] = useState(false);
  const token = localStorage.getItem('moxoDetail');
  const bearerToken = JSON.parse(token);
  const lastCardRef = useRef(null);
  const [unreadCount, setUnreadCount] = useState({});
  const [unreadCounttrigger, setUnreadCounttrigger] = useState({});
  const [animationType, setAnimationType] = useState('right');
  const [hasAnimated, setHasAnimated] = useState(false);

  const handleAnimateComplete = () => {
    setHasAnimated(true);
  };

  const { setIsBinderChatOpen } = useContext(PropertyContext);

  useEffect(() => {
    if (!lastCardRef.current) return;
    if (scrollDoneRef.current) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        lastCardRef.current?.scrollIntoView({
          behavior: 'smooth',
          inline: 'end',
          block: 'nearest',
        });

        scrollDoneRef.current = true;

        scrollTimerRef.current = setTimeout(() => {
          scrollDoneRef.current = false;
        }, 1000);
      });
    });

    return () => {
      if (scrollTimerRef.current) {
        clearTimeout(scrollTimerRef.current);
        scrollTimerRef.current = null;
      }
    };
  }, [loopdata.length]);

  const TitleIcons = styled(Box)(({ theme, unreadCountTrigger }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '500px',
    height: '100%',
    zIndex: 1400,
    backgroundColor: unreadCountTrigger ? '#f0e8fa' : '#345B83', // Flash background color
    padding: '0px 15px',
    animation: unreadCountTrigger && 'deepFlashAnimation 0.5s infinite', // Apply animation only when trigger is true
    '@keyframes deepFlashAnimation': {
      '50%': {
        backgroundColor: '#ffffff', // Flash effect (white)
      },
      '100%': {
        backgroundColor: '#345B83', // Default background color
      },
    },
  }));

  const useStyles = makeStyles({
    innericons: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    maincard: {
      minWidth: '500px',
      height: '100%',
      display: 'flex',
      justifyContent: 'right',
      zIndex: 1,
    },
    emptycard: {
      minWidth: '500px',
      height: '100%',
      display: 'flex',
      justifyContent: 'right',
      visibility: 'hidden',
    },
    bindernames: {
      fontFamily: 'Poppins !important',
      fontSize: '10px',
      color: '#ffff',
      padding: '0px 15px',
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
    },
    avatarstyle: {
      ...poppins500,
      fontSize: '10px',
      color: '#ffff',
      display: 'flex',
      alignItems: 'center',
    },
  });

  const classes = useStyles();

  const Openmessage = (id) => {
    if (LOGGED_FROM == 'Mobile') {
      window.open(
        `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${id}`,
        '_blank'
      );
    } else {
      setShowMessage(true);
      setMessagedata({ binderId: id });
    }
  };

  const Uparrow = () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />

      <path
        d="M4.52686 12.3242L10.725 6.3387L16.7105 12.5369"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        transform="translate(4 3.5)"
      />
    </svg>
  );

  const CenteredXIcon = () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
        fill="white"
      />
      <line
        x1="10"
        y1="10"
        x2="21"
        y2="20"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="10"
        y1="20"
        x2="21"
        y2="10"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );

  const Openchatbox = (id) => {
    setHasAnimated(false);
    setAnimationType('bottom');

    if (ischatopen == '') {
      setIschatopen(id);
      setOpenchat(true);
    } else {
      setIschatopen(id);
    }
    setLoopdata((prevData) => {
      const itemIndex = prevData.findIndex((item) => item.id === id);
      if (itemIndex === -1) return prevData; // Item not found

      const [itemToMove] = prevData.splice(itemIndex, 1);
      return [...prevData, itemToMove];
    });
  };

  const fetchData = async () => {
    if (moxochatloop?.length > 0) {
      const dataPromises = moxochatloop.map((item) =>
        getMoxoBinderdetails(item)
      );

      try {
        const dataResults = await Promise.all(dataPromises);

        const newData = dataResults.filter(Boolean);

        setLoopdata(newData);

        const initialUnreadCounts = {};
        const initialUnreadCountstrigger = {};

        newData.forEach((item) => {
          initialUnreadCounts[item.id] = item.unread_feeds;

          if (
            unreadCount[item.id] !== undefined &&
            unreadCount[item.id] !== item.unread_feeds
          ) {
            initialUnreadCountstrigger[item.id] = true;
          } else {
            initialUnreadCountstrigger[item.id] = false;
          }
        });

        setUnreadCount(initialUnreadCounts);
        setUnreadCounttrigger(initialUnreadCountstrigger);
      } catch (error) {
        console.error('Error fetching binder details:', error);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 5000);
    return () => clearInterval(interval);
  }, [moxochatloop, unreadCount]);

  useEffect(() => {
    fetchData();
  }, [moxochatloop]);

  const RemoveItem = (itemToRemove) => {
    setMoxochatloop((prevItems) =>
      prevItems.filter((item) => item !== itemToRemove)
    );
  };

  return (
    <>
      {loopdata?.length > 0 ? (
        <>
          {loopdata?.map(
            (item, index) =>
              ischatopen != item?.id && (
                <Card
                  className={classes.maincard}
                  key={index}
                  ref={index === loopdata.length - 1 ? lastCardRef : null}
                >
                  <TitleIcons unreadCountTrigger={unreadCounttrigger[item.id]}>
                    <Typography className={classes.innericons}>
                      <IconButton
                        onClick={() => {
                          Openmessage(item?.id);
                        }}
                        disableRipple
                        sx={{
                          backgroundColor: '#ffff',
                          borderRadius: '5px',
                          padding: '0px',
                        }}
                      >
                        <ExpandIcon />
                      </IconButton>

                      <Typography className={classes.avatarstyle}>
                        <Typography>
                          <CommunicationAvataGroup icon={item?.users} />
                        </Typography>
                        {/* <Typography sx={{ ...poppins400, ...fontsize10, color: "#ffff" }}>
                                        &nbsp;{item?.users?.length}
                                    </Typography> */}
                      </Typography>
                    </Typography>
                    <Typography
                      className={classes.bindernames}
                      sx={{
                        color: unreadCounttrigger[item.id] ? '#000' : '#fff',
                      }}
                    >
                      <Badge
                        badgeContent={unreadCount[item.id]?.toString() || 0}
                        color="error"
                        overlap="circular"
                        invisible={unreadCount[item.id] == 0}
                        sx={{
                          '& .MuiBadge-dot': {
                            backgroundColor: '#f44336',
                          },
                          maxWidth: '100%',
                          minWidth: 0,

                          '& .MuiBadge-badge': {
                            position: 'absolute',
                            right: '-5px !important',
                            fontFamily: 'poppins',
                          },
                        }}
                      >
                        <Typography
                          title={item?.name}
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            color: unreadCounttrigger[item.id]
                              ? '#000'
                              : '#fff',

                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,

                            lineHeight: '20px',
                            // maxHeight: '28px',
                            wordBreak: 'break-word',
                          }}
                        >
                          {item?.name}
                        </Typography>
                      </Badge>
                    </Typography>

                    <Typography className={classes.innericons}>
                      <IconButton
                        onClick={() => {
                          Openchatbox(item?.id);
                          setIsBinderChatOpen(true);
                        }}
                        disableRipple
                        sx={{
                          backgroundColor: '#ffff',
                          borderRadius: '5px',
                          padding: '0px',
                        }}
                      >
                        <Uparrow />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          RemoveItem(item?.id);
                        }}
                        disableRipple
                        sx={{
                          backgroundColor: '#ffff',
                          borderRadius: '5px',
                          padding: '0px',
                        }}
                      >
                        <CenteredXIcon />
                      </IconButton>
                    </Typography>
                  </TitleIcons>
                </Card>
              )
          )}
          {ischatopen != '' && <Card className={classes.emptycard}></Card>}
        </>
      ) : null}

      {openchat && (
        <Moxochat
          open={openchat}
          onClose={setOpenchat}
          fromloop={true}
          hasAnimated={hasAnimated}
          animationType={animationType}
          onAnimateComplete={handleAnimateComplete}
        />
      )}
    </>
  );
}

export default Moxochatloop;
